module.exports = __webpack_public_path__ + "img/57_29.7636def4.png";